import * as actionTypes from '../actions/totals';

const initialState = {
  loading: false,
  reports: 0,
  amount: 0
};

const totalsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_TOTAL_START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_TOTAL_SUCCESS: {
      const { data } = action.payload.data;
      const reports = data && data.length > 0 ? data[0]['Totals.reports'] : 0;
      const amount = data && data.length > 0 ? data[0]['Totals.amount'] : 0;
      return {
        ...state,
        loading: false,
        amount,
        reports
      };
    }
    case actionTypes.GET_TOTAL_ERROR:
      return {
        ...state,
        loading: false
      };
    default: {
      return state;
    }
  }
};

export default totalsReducer;
